import { applyMiddleware, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import rootSaga from '../sagas';
import reducer from './reducer';

export const sagaMiddleware = createSagaMiddleware();

const middleware = applyMiddleware(sagaMiddleware);

// devtoolsは開発環境のみ有効化（本番ビルドに含まれないようにする）
const enhancer = process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(middleware)
  : middleware;

const store = createStore(reducer, enhancer);
sagaMiddleware.run(rootSaga);
export default store;
